import { FetchError, SDKResponse } from '@commercetools/frontend-sdk';
import { sdk } from 'sdk';

class PaymentService {
  private paymentsMethodPromise: Record<string, Promise<SDKResponse<unknown>> | null> = {};

  public async paymentMethodsList(locale: string): Promise<SDKResponse<unknown>> {
    try {
      if (!this.paymentsMethodPromise[locale]) {
        this.paymentsMethodPromise[locale] = sdk.callAction({ actionName: 'product/getCustomObjectPayments' });
      }
      const result = await this.paymentsMethodPromise[locale];
      return result as SDKResponse<unknown>;
    } catch (error) {
      this.paymentsMethodPromise[locale] = null;
      return {
        isError: true,
        error: error as FetchError,
      };
    }
  }
}

const paymentService = new PaymentService();

export default paymentService;
